/**
 * Links im Beitragstext erkennen (Marcel 2026-09-20): reine Funktion, die einen
 * Text in Text- und Link-Segmente zerlegt. Erkennt http(s)://… und www.… ;
 * abschließende Satzzeichen (.,;:!?) und schließende Klammern bleiben Text.
 */
export type TextSegment = { type: 'text'; value: string } | { type: 'link'; value: string; href: string };

const URL_RE = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
const TRAILING_RE = /[.,;:!?)\]}'"»”]+$/;

export function linkifyText(text: string | null | undefined): TextSegment[] {
  const input = typeof text === 'string' ? text : '';
  if (input.length === 0) return [];
  const out: TextSegment[] = [];
  const pushText = (value: string) => {
    if (!value) return;
    const prev = out[out.length - 1];
    if (prev && prev.type === 'text') prev.value += value; // benachbarte Textteile zusammenführen
    else out.push({ type: 'text', value });
  };
  let last = 0;
  const re = new RegExp(URL_RE.source, 'gi');
  let match: RegExpExecArray | null;
  while ((match = re.exec(input)) !== null) {
    const start = match.index ?? 0;
    let raw = match[0];
    // Satzzeichen am Ende gehören nicht zur URL (Klammern nur, wenn sie nicht geöffnet wurden)
    let trailing = '';
    const m = raw.match(TRAILING_RE);
    if (m) {
      let cut = m[0];
      // "(…)" innerhalb der URL: eine schließende Klammer pro geöffneter behalten
      while (cut.startsWith(')') && (raw.match(/\(/g) ?? []).length > (raw.slice(0, raw.length - cut.length).match(/\)/g) ?? []).length) {
        cut = cut.slice(1);
      }
      trailing = cut;
      raw = raw.slice(0, raw.length - cut.length);
    }
    if (start > last) pushText(input.slice(last, start));
    if (raw.length > 0) {
      out.push({ type: 'link', value: raw, href: /^https?:\/\//i.test(raw) ? raw : `https://${raw}` });
    }
    pushText(trailing);
    last = start + match[0].length;
  }
  if (last < input.length) pushText(input.slice(last));
  return out;
}

/** Enthält der Text mindestens einen Link? */
export function hasLink(text: string | null | undefined): boolean {
  return linkifyText(text).some((s) => s.type === 'link');
}
